import React from 'react';
import "./SwitchBanner.css";

const SwitchBanner = ({setActive}) => {
    const setToPhotos = () => setActive('Photos');
    const setToVideos = () => setActive('Videos');
    return <div className="sb-container">
        <div className="sb-button tan-background" onClick={setToPhotos}><h3>Photos</h3></div>
        <div className="sb-button red-background" onClick={setToVideos}><h3>Videos</h3></div>
    </div>
};

export default SwitchBanner;